var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTql = function SvgTql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.666 4v5.333A1.333 1.333 0 0020 10.667h5.333M18.667 4H9.332a2.667 2.667 0 00-2.667 2.667V16m12-12l6.667 6.667m0 0V16M24 20v8h2.666m-8.333-1.333l2 2M17 20a2.667 2.667 0 012.666 2.667v2.666a2.667 2.667 0 11-5.333 0v-2.666A2.667 2.667 0 0117 20zM7 20h4m-2 0v8",
    stroke: "#089BEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTql;